import { combineReducers } from 'redux';

import union from 'lodash/union';

import * as types from '../../../types/static-catalogs';

const byId = (state = {}, action) => {
  switch (action.type) {
    //TYPES COMPLETED FETCH, ADD AND EDIT
    case types.SENSOR_MEASURES_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = { ...state };
      order.forEach((measureId) => {
        newState[measureId] = {
          isSelected: false,
          ...state[measureId],
          ...entities[measureId],
          isConfirmed: true
        };
      });
      return newState;
    }
    case types.SENSOR_MEASURES_CLEAR: {
      return {};
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    //CASE COMPLETED FETCH, ADD AND REMOVE
    case types.SENSOR_MEASURES_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }
    case types.SENSOR_MEASURES_CLEAR: {
      return [];
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

// STATES TO KNOW IF IT IS FETCHING, ADDING  OR EDITING
const isFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.SENSOR_MEASURES_FETCH_STARTED: {
      return true;
    }
    case types.SENSOR_MEASURES_FETCH_COMPLETED:
    case types.SENSOR_MEASURES_FETCH_FAILED: {
      return false;
    }
    case types.SENSOR_MEASURES_CLEAR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const errorFetchingList = (state = null, action) => {
  switch (action.type) {
    case types.SENSOR_MEASURES_FETCH_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.SENSOR_MEASURES_CLEAR:
    case types.SENSOR_MEASURES_FETCH_STARTED:
    case types.SENSOR_MEASURES_FETCH_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const sensorMeasures = combineReducers({
  byId,
  order,
  isFetchingList,
  errorFetchingList
});

export default sensorMeasures;

//Own state
export const getOwnState = (state) => state.staticCatalogs.sensorMeasures;

//Information
export const getSensorMeasure = (state, measureId) => getOwnState(state).byId[measureId];
export const getSensorMeasuresList = (state) =>
  getOwnState(state).order.map((id) => getSensorMeasure(state, id));

//Status of sagas
export const isFetchingListSensorMeasures = (state) => getOwnState(state).isFetchingList;

//Errors
export const getFetchingListSensorMeasuresErrors = (state) => getOwnState(state).errorFetchingList;
